import Icon from '../Icon/Icon.js'
import { InputQtyButton, InputQtyValue, InputQtyWrapper } from './InputQty.styles.js'

const InputQty = ({ value, onChange }) => {
  return (
    <InputQtyWrapper>
      <InputQtyButton onClick={() => onChange(value - 1)} disabled={value <= 1}>
        <Icon name="minus" />
      </InputQtyButton>
      <InputQtyValue>{value}</InputQtyValue>
      <InputQtyButton onClick={() => onChange(value + 1)}>
        <Icon name="plus" />
      </InputQtyButton>
    </InputQtyWrapper>
  )
}

export default InputQty
